import React, { useState, useEffect, useMemo } from "react"
import Skeleton from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"
import { Link, useNavigate } from "react-router-dom"
import Swal from "sweetalert2"
import { toast } from "react-toastify"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import TableContainer from "../../components/Common/DataTableContainer"

import { useDispatch, useSelector } from "react-redux"
import axios from "axios"
import { fetchWasteData } from "store/waste/actions"

const Waste = props => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { data, loading, error } = useSelector(state => state.Waste)

  useEffect(() => {
    dispatch(fetchWasteData())
  }, [dispatch])

  const handleDelete = async id => {
    Swal.fire({
      title: "Are you sure you want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          const token = localStorage.getItem("authToken")
          const response = await axios.post(
            `${process.env.REACT_APP_WEB_APP_URL}/api/web/waste-load-types/delete/${id}`,
            {},
            {
              headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          )
          if (response.status === 200) {
            toast.success("Waste type has been deleted.", { autoClose: 3000 })
            dispatch(fetchWasteData())
          } else {
            toast.error(response?.message || "Failed to delete", {
              autoClose: 3000,
            })
          }
        } catch (error) {
          console.error(error)
          toast.error("Failed to delete waste type", { autoClose: 3000 })
        }
      }
    })
  }

  const columns = useMemo(
    () => [
      {
        header: "Image",
        accessorKey: "icon_url",
        enableColumnFilter: false,
        cell: ({ row }) => (
          <img
            src={row.original.icon_url || row.original.icon || "assets/images/no-image.png"}
            alt="Profile"
            style={{ width: 40, height: 40, borderRadius: "50%" }}
          />
        ),
      },
      {
        header: "Name",
        accessorKey: "title",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Name (Arabic)",
        accessorKey: "title_ar",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Is Active",
        accessorKey: "is_active",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Actions",
        id: "actions",
        cell: ({ row }) => {
          const wasteId = row.original?.id
          return (
            <div>
              <button
                className="btn btn-sm btn-success mx-2"
                onClick={() => navigate(`/waste/edit/${wasteId}`)}
              >
                <i className="mdi mdi-pencil"></i> Edit
              </button>
              <button
                className="btn btn-sm btn-danger"
                onClick={() => handleDelete(wasteId)}
              >
                <i className="mdi mdi-delete"></i> Delete
              </button>
            </div>
          )
        },
      },
    ],
    []
  )

  const totalRecords = data?.data?.length ?? 0

  const transformedData = useMemo(() => {
    return data?.data?.map(item => {
      return {
        ...item,
        icon: item.icon_url || item.icon || "assets/images/no-image.png",
        icon_url: item.icon_url || item.icon || "assets/images/no-image.png",
        title: item.title ?? "N/A",
        title_ar: item.title_ar ?? "N/A",
        is_active: item?.is_active ?? "N/A",
      }
    })
  }, [data])

  document.title = "Waste Types | Moeen"

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Home" breadcrumbItem="Waste Types" />
        <div className="float-end d-none d-md-block">
          <Link
            to="/waste/create"
            color="primary"
            className="btn btn-primary text-white waves-effect waves-light"
          >
            Add Waste Type
          </Link>
        </div>
        {loading ? (
          <Skeleton count={10} height={40} />
        ) : (
          <TableContainer
            columns={columns}
            data={transformedData || []}
            isGlobalFilter={true}
            isPagination={true}
            SearchPlaceholder={`Looking for something? ${totalRecords} results loaded.`}
            pagination="pagination"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        )}
      </div>
    </div>
  )
}

export default Waste
